import { NgModule } from '@angular/core'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import {
  provideAnalytics,
  getAnalytics,
  ScreenTrackingService,
  UserTrackingService
} from '@angular/fire/analytics'
import { environment } from 'src/environments/environment'
import { getAuth, provideAuth } from '@angular/fire/auth'

const analyticsCookiesEnabled =
  !environment.disableAnalyticsCookies &&
  Boolean(environment.hotjarConfig || environment.firebaseConfig?.measurementId)

const analyticsProviders =
  !analyticsCookiesEnabled || !environment.firebaseConfig?.measurementId
  ? []
  : [
      provideAnalytics(() => getAnalytics()),
      ScreenTrackingService,
      UserTrackingService
    ]

@NgModule({
  imports: [],
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    ...analyticsProviders
  ]
})
export class FireBaseModule {}
